// extracted by mini-css-extract-plugin
export default {"backButton":"backButton_backButton__fvpco","arrowLeftLong":"backButton_arrowLeftLong__uik8p"};